import ReducedPrice from './ReducedPrice';
export default ReducedPrice;